// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__1_xNI","icon":"styles_icon__1XFze","info":"styles_info__3kKGD"};